import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";
import {
  COMPANY_LOAN_BID_FRAGMENT,
  INVOICE_PURCHASE_BID_FRAGMENT,
  LEASING_BID_FRAGMENT,
  LENDER_RESPONSE_FRAGMENT,
  REAL_ESTATE_LOAN_BID_FRAGMENT,
  REVOLVING_CREDIT_BID_FRAGMENT,
} from "@krea/customer-features/graphql/lender-response/lender-response.fragment";
import { IBids } from "@krea/customer-features/types/lenderResponse";

const GET_LENDER_RESPONSES = gql`
  query GetLenderResponses {
    me {
      currentLoanApplication {
        id
        recommendedLenderResponse {
          id
        }

        invoicePurchaseBids {
          ...InvoicePurchaseBidFragment
          lenderResponse {
            ...LenderResponseFragment
          }
        }

        companyLoanBids {
          ...CompanyLoanBidFragment
          lenderResponse {
            ...LenderResponseFragment
          }
        }

        realEstateBids {
          ...RealEstateLoanBidFragment
          lenderResponse {
            ...LenderResponseFragment
          }
        }

        leasingBids {
          ...LeasingBidFragment
          lenderResponse {
            ...LenderResponseFragment
          }
        }

        revolvingCreditBids {
          ...RevolvingCreditBidFragment
          lenderResponse {
            ...LenderResponseFragment
          }
        }
      }
    }
  }

  ${INVOICE_PURCHASE_BID_FRAGMENT}
  ${LENDER_RESPONSE_FRAGMENT}
  ${COMPANY_LOAN_BID_FRAGMENT}
  ${REAL_ESTATE_LOAN_BID_FRAGMENT}
  ${LEASING_BID_FRAGMENT}
  ${REVOLVING_CREDIT_BID_FRAGMENT}
`;

export interface IFetchLenderResponsesResponse {
  me?: {
    currentLoanApplication?: IBids;
  };
}

export const getLenderResponses = async () => {
  return await client.request<IFetchLenderResponsesResponse>(
    GET_LENDER_RESPONSES,
  );
};
